import React, { useMemo } from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'modules/Referral/PayoutProfiles/Invoices/subcomponents/StatusIcon/status-icon.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const ICONS = {
  new: {
    icon: 'money',
    color: 'Interface-GU-Primary',
  },
  pending: {
    icon: 'time-clock',
    color: 'Accent-Notice-Primary',
  },
  declined: {
    icon: 'close',
    color: 'Label-Error-Primary',
  },
  handled: {
    icon: 'money',
    color: 'Label-Confirm',
  },
  blocked: {
    icon: 'lock',
    color: 'Label-Error-Primary',
  },
  cancelled: {
    icon: 'close',
    color: 'Label-Error-Primary',
  },
}

const StatusIcon = ({ status }) => {
  const config = useMemo(() => ICONS[status], [status])

  if (!config) {
    return null
  }

  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], styles[`container_${status}`])}
    >
      <Icon
        name={config.icon}
        size={'m'}
        color={config.color}
        className={styles['icon']}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf([
    'new',
    'pending',
    'declined',
    'handled',
    'blocked',
    'cancelled',
  ]),
  breakpoints: PropTypes.object,
}

export default StatusIcon
